import axios from "axios"
import { toast } from "react-toastify"

const fetchDeleteSingleManagerMessageRequest = () => {
	return {type: "FETCH_DELETE_SINGLE_MANAGER_MESSAGE_REQUEST"}
}

const fetchDeleteSingleManagerMessageSuccess = (delete_manager_message) => {
	return {type: "FETCH_DELETE_SINGLE_MANAGER_MESSAGE_SUCCESS", payload: delete_manager_message}
}

const fetchDeleteSingleManagerMessageFailure = (error) => {
	return {type: "FETCH_DELETE_SINGLE_MANAGER_MESSAGE_FAILURE", payload: error}
}

export const fetchDeleteSingleManagerMessage = (id) => {
	return (dispatch) => {
		dispatch(fetchDeleteSingleManagerMessageRequest())
		axios.delete(`admin/system/message/${id}`)
		.then(response => {
			const delete_manager_message = response.data
			toast.dismiss()
			toast.success("با موفقیت حذف شد" , {position: 'bottom-right'})
			dispatch(fetchDeleteSingleManagerMessageSuccess(delete_manager_message))
		})
		.catch(err => {
			const error = err.message
			toast.dismiss()
			toast.error("مشکلی پیش آمده است" , {position: 'bottom-right',className: 'foo-bar'})
			dispatch(fetchDeleteSingleManagerMessageFailure(error))	
		})
	}
}

